import { render, staticRenderFns } from "./view-multi-account-management.vue?vue&type=template&id=479ef07a&scoped=true&"
import script from "./view-multi-account-management.vue?vue&type=script&lang=js&"
export * from "./view-multi-account-management.vue?vue&type=script&lang=js&"
import style0 from "./view-multi-account-management.vue?vue&type=style&index=0&id=479ef07a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ef07a",
  null
  
)

export default component.exports